<div *ngIf = "showLoader"class="loading"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
<router-outlet></router-outlet>